// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingProfileWidgetAttention-moduleaction__OFjur";
var _2 = "RentalPortalListingProfileWidgetAttention-modulecontent__ifBRJ WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
export { _1 as "action", _2 as "content" }
